import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Button, Card, Form, Input, notification, Select} from 'antd';

import {addRegulatoryBodyReportingCategory} from './actions';
import {getDescriptionFromError} from "../../utils/errors";
import {formItemLayout} from "../../utils/style";
import {bindActionCreators} from "redux";
import {getRegulatoryBody} from "../actions";
import {decodeParams} from "../../utils/params";

const FormItem = Form.Item;
const ButtonGroup = Button.Group;
const Option = Select.Option;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class AddReportingCategoryForm extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,

    loading: PropTypes.bool.isRequired,
    form: PropTypes.object.isRequired,
    regulatoryBody: PropTypes.object.isRequired,

    getRegulatoryBody: PropTypes.func.isRequired,
    addRegulatoryBodyReportingCategory: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.regulatoryBodyId !== prevProps.match.params.regulatoryBodyId) this.load();
  }

  load = () => {
    const {regulatoryBodyId} = decodeParams(this.props.match.params);
    this.props.getRegulatoryBody({regulatoryBodyId});
  };

  goBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const regulatoryBodyId = this.props.regulatoryBody.regulatoryBodyId;
    this.props.form.validateFields(async(err, values) => {
      if (err) return;
      try {
        await this.props.addRegulatoryBodyReportingCategory({...values, regulatoryBodyId});
        this.goBack();
      } catch (err) {
        notification.error({
          message: 'Failed',
          description: getDescriptionFromError(err)
        });
      }
    });
  };

  render() {
    const {form: {getFieldDecorator, getFieldsError}, loading, regulatoryBody} = this.props;
    if (regulatoryBody) {
      const title = `Add ${regulatoryBody.name} Reporting Category`;
      const availableUnits = ['each', 'kg', 'L', 'lb', 'gal'];
      return (
        <Card bordered={false} title={[
          <Button key="back-button" icon="arrow-left" onClick={this.goBack.bind(this)}/>,
          ' ',
          title,
        ]}>
          <Form onSubmit={this.handleSubmit}>
            <FormItem
              {...formItemLayout}
              label="Name"
            >
              {getFieldDecorator('name', {
                rules: [{
                  required: true,
                  message: 'Name is required'
                }]
              })(
                <Input/>
              )}
            </FormItem>
            <FormItem
              {...formItemLayout}
              label="Unit"
            >
              {getFieldDecorator('reportingUnit', {
                rules: [{
                  required: true
                }]
              })(
                <Select>
                  {availableUnits
                    .map(unit => <Option key={unit} value={unit}>{unit}</Option>)
                  }
                </Select>
              )}
            </FormItem>
            <FormItem>
              <ButtonGroup>
                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={loading || hasErrors(getFieldsError())}
                >
                  Add Reporting Category
                </Button>
                <Button
                  htmlType="button"
                  onClick={this.goBack}
                >
                  Cancel
                </Button>
              </ButtonGroup>
            </FormItem>
          </Form>
        </Card>
      );
    }
    return null;
  }
}

const AddReportingCategoryPage = Form.create()(AddReportingCategoryForm);

const mapStateToProps = state => ({
  loading: state.regulatoryBody.addingRegulatoryBodyReportingCategory || state.regulatoryBody.regulatoryBodyLoading,
  regulatoryBody: state.regulatoryBody.regulatoryBody || {},
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  addRegulatoryBodyReportingCategory,
  getRegulatoryBody,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(AddReportingCategoryPage);



// WEBPACK FOOTER //
// ./src/RegulatoryBody/ReportingCategory/AddReportingCategoryPage.js